import React from 'react';
import PropTypes from 'prop-types';
import ModalCloseButton from 'commons-general/components/ModalCloseButton/ModalCloseButton.jsx';
import Modal from 'commons-general/components/Modal/Modal.jsx';

import ModalService from 'commons-general/services/ModalService/ModalService.js';

class LoginModal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.modal = ModalService.get(this.props.name);
        this.closeModal = this.closeModal.bind(this);
    }
    closeModal() {
        this.modal.close();
    }

    render() {
        const { name, children, contentLabel, className, bckGrndImage } = this.props;
        const content = {
            backgroundImage: bckGrndImage,
        };
        const loginStyle = {
            overlay: {
                zIndex: 2147483643,
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
            },
            content,
        };
        return (
            <Modal name={name} contentLabel={contentLabel} className={className} style={loginStyle}>
                <ModalCloseButton closeAction={this.closeModal} />
                {/* Here we clone children add pass them new props registered into ModalInstance */
                React.Children.map(children, (child) => React.cloneElement(child))}
            </Modal>
        );
    }
}
LoginModal.defaultProps = {
    children: null,
    className: '',
    bckGrndImage: 'none',
};
LoginModal.propTypes = {
    name: PropTypes.string.isRequired,
    children: PropTypes.node,
    contentLabel: PropTypes.string.isRequired,
    className: PropTypes.string,
    bckGrndImage: PropTypes.string,
};

LoginModal.displayName = 'LoginModal';

export default LoginModal;
